// Prepares an image for upload to the server: downsizes it to at most maxSide pixels and returns a data URL.
// PNG stays PNG (logo transparency), unless it turns out too heavy, in which case JPEG is used.
const MAX_BYTES = 380 * 1024; // the server accepts up to 400 KB

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Fajl nije slika koju browser može da otvori"));
    };
    img.src = url;
  });
}

const dataUrlBytes = (u) => Math.floor(((u.length - u.indexOf(",") - 1) * 3) / 4);

export async function fileToResizedDataUrl(file, maxSide = 512) {
  if (!/^image\/(png|jpeg|webp)$/.test(file.type)) {
    throw new Error("Dozvoljeni su PNG, JPEG i WebP");
  }
  const img = await loadImage(file);
  const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
  const w = Math.max(1, Math.round(img.width * scale));
  const h = Math.max(1, Math.round(img.height * scale));
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, w, h);

  let out = canvas.toDataURL("image/png");
  if (dataUrlBytes(out) > MAX_BYTES) {
    // JPEG has no transparency: the background is white
    ctx.globalCompositeOperation = "destination-over";
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, w, h);
    out = canvas.toDataURL("image/jpeg", 0.85);
  }
  if (dataUrlBytes(out) > MAX_BYTES) throw new Error("Slika je prevelika, izaberi manju");
  return out;
}
